import { IonSelect, IonSelectOption, IonIcon, IonLabel } from '@ionic/react';
import React from 'react';
import Utilities from '../Utilities';
import '../styles/ReviewModal.scss';
import 'react-circular-progressbar/dist/styles.css';
import CountTo from 'react-count-to';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';

import FireImg from '../images/fire.png';
import ShieldDiamondImg from '../images/shield-diamond.png';
import ShieldPlatinumImg from '../images/platinum-shield.png';
import ShieldJadeImg from '../images/shield-jade.png';
import ShieldGoldImg from '../images/shield-gold.png';
import ShieldSilverImg from '../images/shield-silver.png';

import { school, closeCircle, checkmarkDoneCircle, golf, checkmarkCircle, hourglass, statsChartSharp, statsChart, share, starHalf, eye, ribbon, rocket } from 'ionicons/icons';

import { Share } from '@capacitor/share';
import { Clipboard } from '@capacitor/clipboard';

class ReviewModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            title: "",
            hasLeveledUp: false,
            xp: null,
            goalWidth: 0,
            levelWidth: 0,
            activeDayStreak: 0
        }
    }

    async componentDidMount() {
        
    }

    async share() {

        // TO DO maybe multi image, with flashcard, all stats, flags etc...

        const text = "I have reviewed " + (this.props.data.after.reviews) + " flashcards in total with the Flashcards made Simple app. Download Now for free to study anything, anytime, anywhere, anyhow. https://flashcardsmadesimple.com"

        Utilities.trackEvent("Share", "Recommend App", "Review Modal")

        if (window.os === "web") {

            Clipboard.write({
                string: text
            });

            setTimeout(() => {
                window.toast(window.ln.copied);
            }, 200)

        } else {

            let shareRet = await Share.share({
                title: "Flashcards made Simple",
                text: text,
                url: "https://flashcardsmadesimple.com",
                dialogTitle: text,
            });

        }

    }

    async componentWillReceiveProps(nextProps) {
        if (nextProps.data && !this.props.data) {
            Utilities.onDrawerShow();
            let prevXp = nextProps.data.before.xp;
            let afterXp = nextProps.data.after.xp;

            // TO DO Say leveled UP
            // TO DO save level up level so won't show again
            let currentXpLevel = null
            let nextXpLevel = null;

            for (let i = 0; i < window.levels.length; i++) {
                if (afterXp < window.levels[i].xp) {
                    currentXpLevel = window.levels[i-1] ? window.levels[i-1] : window.levels[i]
                    nextXpLevel = window.levels[i-1] ? window.levels[i] : window.levels[i+1]
                    break;
                }
            }

            if (!currentXpLevel) {
                currentXpLevel = window.levels[window.levels.length-1];
                nextXpLevel = null;
            }
            
            const totalGapBetweenLevels = nextXpLevel ? (nextXpLevel.xp - currentXpLevel.xp) : null
            const thisLevelXpDone = totalGapBetweenLevels ? (totalGapBetweenLevels - (afterXp - currentXpLevel.xp)) : null

            this.setState({
                xp: {
                    nextLevelName: nextXpLevel ? nextXpLevel.name : "",
                    totalNeededForNextLevel: nextXpLevel ? nextXpLevel.xp : null,
                    current: afterXp,
                    currentLevel: currentXpLevel.level,
                    currentMaterial: currentXpLevel.material,
                    totalGapBetweenLevels: totalGapBetweenLevels,
                    thisLevelXpDone: thisLevelXpDone
                },
                title: Utilities.wellDone(),
                goalWidth: 0,
                levelWidth: 0,
                activeDayStreak: nextProps.data.after.activeDayStreak
            }, () => {
                setTimeout(() => {
                    this.setState({
                        goalWidth: parseInt(window.settings.goalNumber) ? ( this.props.data.after.reviewedCardIdsToday <= parseInt(window.settings.goalNumber) ? (this.props.data.after.reviewedCardIdsToday / parseInt(window.settings.goalNumber)) * 330 : 330 ) : 0,
                        levelWidth: this.state.xp.thisLevelXpDone ? ((this.state.xp.totalGapBetweenLevels - this.state.xp.thisLevelXpDone) / this.state.xp.totalGapBetweenLevels * 330) : 0
                    })
                }, 100)

                Utilities.trackEvent("Practice", "Practice Statistics Show", (this.props.data.after.reviews - this.props.data.before.reviews) + "|" + ( this.props.data && this.props.data.after && this.props.data.before ? this.props.data.after.learnt - this.props.data.before.learnt : 0) + "|" + (this.props.data && this.props.data.after && this.props.data.before ? this.props.data.after.mastered - this.props.data.before.mastered : 0) + "|" + afterXp, this.props.data.after.reviews - this.props.data.before.reviews)
            })

        }
    }

    render() {

        const newLearnt = this.props.data && this.props.data.after && this.props.data.before ? this.props.data.after.learnt - this.props.data.before.learnt : 0;
        const newMastered = this.props.data && this.props.data.after && this.props.data.before ? this.props.data.after.mastered - this.props.data.before.mastered : 0;

        return (
        <SwipeableDrawer
            anchor="bottom"
            open={this.props.data !== null}
            key="flashcard-editor"
            transitionDuration={0}
            className="type-selector"
            onOpen={ () => {
                Utilities.onDrawerShow();
            } }
            onClose={ () => { 
                Utilities.onDrawerHide(); this.props.onClose();
            } }
        >
            <div 
                ref={this.modalRef}
                className="swipeable-drawer-body" 
                className="practice-end-modal" 
                style={{ 
                    position: "absolute",
                    bottom: 0,
                    width: "100%",
                    padding: 15,
                    background: "white",
                    borderRadius: '32px 32px 0 0'
                }} 
                id="share-mdl"
            >
                <div className="drag-indicator"></div>
                <h2>
                    {this.state.title}
                </h2>
                <div className="drag-close-indicator" onClick={() => {
                    Utilities.onDrawerHide();
                    this.props.onClose();
                }}>
                    <IonIcon icon={closeCircle} />
                </div>
                <div className='body'>
                    { this.props.data &&
                        <React.Fragment>
                        <div className='highlights'>
                            <div className='stat'>
                                <IonIcon icon={eye} />
                                <div className='total'>
                                    <CountTo from={0} to={this.props.data.after.reviews} speed={1000}>{(value) => <span>{value}</span>}</CountTo>
                                </div>
                                <p>{window.ln.reviews}</p>
                                <div className='new'>
                                    <CountTo to={this.props.data.after.reviews - this.props.data.before.reviews} speed={1000}>{(value) => <span>{value}</span>}</CountTo> <span>{window.ln.new}</span>
                                </div>
                            </div>

                            <div className='stat'>
                                <IonIcon icon={ribbon} />
                                <div className='total'>
                                    <CountTo from={0} to={this.props.data.after.learnt} speed={1000}>{(value) => <span>{value}</span>}</CountTo>
                                </div>
                                <p>{window.ln.learnt}</p>
                                <div className='new'>
                                    <CountTo to={newLearnt > 0 ? newLearnt : 0} speed={1000}>{(value) => <span>{value}</span>}</CountTo> <span>{window.ln.new}</span>
                                </div>
                            </div>

                            <div className='stat'>
                                <IonIcon icon={rocket} />
                                <div className='total'>
                                    <CountTo from={0} to={this.props.data.after.mastered} speed={1000}>{(value) => <span>{value}</span>}</CountTo>
                                </div>
                                <p>{window.ln.mastered}</p>
                                <div className='new'>
                                    <CountTo to={newMastered > 0 ? newMastered : 0} speed={1000}>{(value) => <span>{value}</span>}</CountTo> <span>{window.ln.new}</span>
                                </div>
                            </div>

                        </div> 

                        <div className='progresses'>
                            
                            { window.settings.goalNumber &&
                                <div className='progress'>
                                    <div className="img">
                                        <span>{this.state.activeDayStreak}</span>
                                        <img src={FireImg} />
                                    </div>
                                    <div className='done' style={{ width:  this.state.goalWidth }}> </div>
                                    { (parseInt(window.settings.goalNumber) > this.props.data.after.reviewedCardIdsToday) ?
                                        <div className='text'>
                                            <strong>{window.ln.reviewsLeftGoal.replace("__", parseInt(window.settings.goalNumber) - this.props.data.after.reviewedCardIdsToday)}</strong>
                                        </div>
                                        :
                                        <div className='text'>
                                            <strong>{window.ln.dailyGoalAchieved}</strong>
                                        </div>
                                    }
                                </div>
                            }

                            {/* <div 
                                className='right'
                                onClick={() => {
                                    this.props.onClose();
                                    if (document.getElementById("goal-select")) {
                                        document.getElementById("goal-select").click();
                                    } else {
                                        window.goBack();
                                        setTimeout(() => {
                                            if (document.getElementById("goal-select").click()) {
                                                document.getElementById("goal-select").click();
                                            }
                                        }, 1000)
                                    }
                                }}
                            >
                                <button>{window.ln.setUp}</button>
                            </div> */}

                            { (this.state.xp && this.state.xp.totalNeededForNextLevel !== null) &&
                                <div className='progress'>
                                    <div className="img shield">
                                        <span>{this.state.xp.currentLevel}</span>
                                        <img src={ this.state.xp.currentMaterial === 1 ? ShieldSilverImg : this.state.xp.currentMaterial === 2 ? ShieldGoldImg : this.state.xp.currentMaterial === 3 ? ShieldPlatinumImg : this.state.xp.currentMaterial === 4 ? ShieldDiamondImg : ShieldJadeImg } />
                                    </div>
                                    <div className='done' style={{ width: this.state.levelWidth }}> </div>
                                    <div className='text'>
                                        <strong>{this.state.xp.totalNeededForNextLevel - this.state.xp.current}XP</strong> for {this.state.xp.nextLevelName}
                                    </div>
                                </div>
                            }
                        </div>
                        </React.Fragment>
                    }
                    <div className='opts'>
                        <button onClick={() => {
                            this.props.onClose();
                            this.props.history.push("/stats");
                        }}>
                            <IonIcon icon={statsChart} />
                            <span>{window.ln.allStats}</span>
                        </button>
                        <button onClick={() => {
                            Utilities.trackEvent("Rate", window.os === "android" ? "Open Google Play" : "Open AppStore", "Review Modal")
                            window.open(window.os === "android" ? "https://play.google.com/store/apps/details?id=com.dominikgyecsek.simplecards" : "https://itunes.apple.com/gb/app/id1496147001")
                        }}>
                            <IonIcon icon={starHalf} />
                            <span>{window.ln.rateApp}</span>
                        </button>
                        <button onClick={() => { this.share(); }}>
                            <IonIcon icon={share} />
                            <span>{window.ln.share}</span>
                        </button>
                    </div>
                </div>
            </div>
        </SwipeableDrawer>)
    }

};

export default ReviewModal;
